<template>
  <div class="article-3">
    <div class="article__info">
      <h1 class="article__title">虛擬空間的數位戰場</h1>
      <h2 class="article__subtitle">社群媒體 蔡韓柯各領風騷</h2>
      <div class="article__reporter">聯合報 記者：張文馨／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-3-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <SvgSymbol class="article__figure-caption-icon" use="#figure-caption-icon"/>
        <span>柯文哲參加青年帶冠禮。記者林俊良／攝影</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">為吸引年輕人的目光，網路上的社交媒體成為主要溝通管道，虛擬的數位空間，早成為大選主戰場。</p>
    <p class="article__paragraph">各陣營的參選人努力經營，在不同社群深耕票源，相關數據顯示，台北市長柯文哲的主力就是年輕族群，民進黨總統參選人蔡英文在後追趕、積極搶攻，國民黨總統參選人韓國瑜則是擴散潛力十足。</p>
    <p class="article__paragraph">前陣子，蔡英文前往Dcard參觀，這是以學生為主要使用族群的知名網路社群，有別於台灣老牌社群媒體PTT在1995年推出後，當年就讀大學的使用者，如今已經40多歲，雖然現在仍有許多學生使用，卻不像Dcard的族群更加年輕。</p>
    <p class="article__paragraph">這顯示蔡英文重視年輕人的溝通管道，企圖心明顯。因為她在數位戰場對青年族群的影響，恐怕不及柯文哲。以Instagram為例，使用者以低於24歲的人最多，柯文哲的追蹤人數97萬人，蔡英文只有36.3萬人，韓國瑜才8.4萬人。</p>
    <p class="article__paragraph">YouTube是以影音為主，使用者的年齡層在近年來雖有拉高趨勢，但24歲以下的年輕人仍占多數，目前訂閱柯文哲影音頻道有44.8萬人，蔡英文約22萬人，韓國瑜有10.7萬人。</p>

    <!-- chart-1 -->
    <div class="article__chart">
      <div class="article__chart-caption">Instagram, YouTube - 24 歲以下年輕人愛用</div>
      <div class="article__chart-figure article-3__chart-figure-1">
        <SvgSymbol use="#article-3-chart-1"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：YouTube & Instagram</span><!--
      --><span>統計日期：2019/10/14</span>
      </div>
    </div>

    <p class="article__paragraph">Facebook的使用族群，目前以25歲到55歲為主，年齡層分布較平均，許多政治人物都開設粉絲專頁，目前蔡英文的粉絲最多，高達247.9萬人，柯文哲歷經退讚潮後，仍維持在196.3萬人，韓國瑜則有79.4萬人，至於後來才宣布參總統的呂秀蓮，粉絲有1.3萬人。 </p>
    <p class="article__paragraph">Line的使用族群同樣橫跨多數年齡層，許多人喜歡在特定群組裡分享文章，更具有擴散效果，被視為凝聚力和動員力的重要工具。蔡英文的Line好友人數，高達60萬人，領先其他競爭者，韓國瑜則是緊跟在後，約有59.8萬人，相形之下，柯文哲只有38.2萬人。</p>

    <!-- chart-2 -->
    <div class="article__chart">
      <div class="article__chart-caption">Line, Facebook - 使用者遍布各年齡層</div>
      <div class="article__chart-figure article-3__chart-figure-2">
        <SvgSymbol use="#article-3-chart-2"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：Facebook & Line</span><!--
      --><span>統計日期：2019/10/14</span>
      </div>
    </div>

    <p class="article__paragraph">由於Facebook的觸及率，可達到較多年齡層，是各陣營經營社群的核心，貼文數較多；整體來說，蔡英文發文居冠，韓國瑜其次，反倒是柯文哲偏少。這些人的網路小編發文，刻意選擇多數人瀏覽的時間，主要集中在一早上班前、午休和傍晚下班後，以爭取最大效益。</p>

    <!-- chart-3 -->
    <div class="article__chart">
      <div class="article__chart-caption">政治人物在 Facebook 的發文數</div>
      <div class="article__chart-figure article-3__chart-figure-3">
        <SvgSymbol use="#article-3-chart-3"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：CrowdTangle</span><!--
      --><span>統計日期：2019/7/1-9/30</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Article3'
}
</script>

<style lang="scss">
.article-3 {

  &__chart-figure {
    &-1 {
      @include use-fixed-ratio(821.51, 772.11);
    }

    &-2 {
      @include use-fixed-ratio(1026.79, 912.48);
    }

    &-3 {
      @include use-fixed-ratio(1158.94, 1216.03);
    }
  }
}
</style>
